(function () {
  var upsellSyncTimer = null;
  var upsellSyncToken = 0;
  var UPSELL_SYNC_DELAY = 220;

  function getCartTotalQuantity(cart) {
    if (!cart) {
      return 0;
    }

    if (cart.item_count != null) {
      return parseInt(cart.item_count, 10) || 0;
    }

    if (Array.isArray(cart.items)) {
      return cart.items.reduce(function (sum, item) {
        return sum + (parseInt(item.quantity, 10) || 0);
      }, 0);
    }

    return 0;
  }

  function formatUpsellBogoLabel(itemCount, bogoType) {
    var strings = (typeof theme !== 'undefined' && theme.strings) ? theme.strings : {};
    var isAccessories = bogoType === 'accessories';

    if (itemCount <= 0) {
      return '';
    }

    var remainder = itemCount % 3;

    if (remainder === 0) {
      if (isAccessories) {
        return strings.cartUpsellAccessoriesBogoQualified || 'Your free accessory is included!';
      }

      return strings.cartUpsellBogoQualified || 'Your free piece is included!';
    }

    if (remainder === 2) {
      if (isAccessories) {
        return strings.cartUpsellAccessoriesBogoOneAway || 'Add 1 more accessory and it becomes FREE!';
      }

      return strings.cartUpsellBogoOneAway || 'Add 1 more piece and it becomes FREE!';
    }

    if (remainder === 1) {
      if (isAccessories) {
        return strings.cartUpsellAccessoriesBogoTwoAwayFirst || 'Add 1 more accessory and get the next one on us.';
      }

      return strings.cartUpsellBogoTwoAwayFirst || 'Add 1 more piece and get the next one on us.';
    }

    if (isAccessories) {
      return strings.cartUpsellAccessoriesBogoTwoAway || 'Add 2 more accessories — your 3rd is FREE';
    }

    return strings.cartUpsellBogoTwoAway || 'Add 2 more pieces — your 3rd is FREE';
  }

  function updateUpsellDiscountLabel(upsell, itemCount) {
    var discountEl = upsell.querySelector('[data-bdl-cart-upsell-discount]');
    if (!discountEl) {
      return;
    }

    var bogoType = upsell.getAttribute('data-bdl-cart-upsell-bogo') || 'dress';
    discountEl.textContent = formatUpsellBogoLabel(itemCount, bogoType);
  }

  function applyUpsellFromCart(cart) {
    if (!cart) {
      return;
    }

    var upsells = document.querySelectorAll('[data-bdl-cart-upsell]');
    if (!upsells.length) {
      return;
    }

    var itemCount = getCartTotalQuantity(cart);
    var handles = cart && Array.isArray(cart.items)
      ? cart.items.map(function (item) {
        return item.handle;
      })
      : [];

    upsells.forEach(function (upsell) {
      if (handles.length) {
        upsell.querySelectorAll('[data-product-handle]').forEach(function (card) {
          var hide = handles.indexOf(card.getAttribute('data-product-handle')) !== -1;
          card.style.display = hide ? 'none' : '';
        });
      }

      upsell.hidden = itemCount === 0;
      updateUpsellDiscountLabel(upsell, itemCount);
    });
  }

  function clearUpsellPanelTransition(panel) {
    if (!panel || !panel._bdlUpsellTransitionEnd) {
      return;
    }

    panel.removeEventListener('transitionend', panel._bdlUpsellTransitionEnd);
    panel._bdlUpsellTransitionEnd = null;
  }

  function initUpsellCollapsibles(scope) {
    var root = scope || document;
    var upsells = root.querySelectorAll ? root.querySelectorAll('[data-bdl-cart-upsell]') : [];

    upsells.forEach(function (upsell) {
      var trigger = upsell.querySelector('[data-bdl-cart-upsell-toggle]');
      var panel = upsell.querySelector('[data-bdl-cart-upsell-panel]');
      var inner = panel && panel.querySelector('.bdl-cart-upsell__panel-inner');

      if (!trigger || !panel || !inner || trigger.dataset.bdlCartUpsellAccordion === 'true') {
        return;
      }

      trigger.dataset.bdlCartUpsellAccordion = 'true';

      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var isOpen = trigger.getAttribute('aria-expanded') === 'true';

        clearUpsellPanelTransition(panel);

        if (isOpen) {
          panel.style.height = inner.offsetHeight + 'px';
          void panel.offsetHeight;
          trigger.setAttribute('aria-expanded', 'false');
          trigger.classList.remove('is-open');
          panel.classList.remove('is-open');
          panel.style.height = '0';
          return;
        }

        trigger.setAttribute('aria-expanded', 'true');
        trigger.classList.add('is-open');
        panel.classList.add('is-open');
        panel.style.height = '0';
        void panel.offsetHeight;
        panel.style.height = inner.offsetHeight + 'px';

        panel._bdlUpsellTransitionEnd = function (evt) {
          if (evt.target !== panel || evt.propertyName !== 'height') {
            return;
          }

          clearUpsellPanelTransition(panel);

          if (trigger.getAttribute('aria-expanded') === 'true') {
            panel.style.height = 'auto';
          }
        };

        panel.addEventListener('transitionend', panel._bdlUpsellTransitionEnd);
      });
    });
  }

  function extractSectionHtml(html) {
    if (!html || html.indexOf('shopify-section') === -1) {
      return html;
    }

    var template = document.createElement('template');
    template.innerHTML = html.trim();
    var section = template.content.querySelector('.shopify-section');

    return section ? section.innerHTML : html;
  }

  var activeQuickAddPanel = null;
  var cartQuickAddLoading = false;
  var QUICK_ADD_SHEET_DURATION = 580;
  var QUICK_ADD_BACKDROP_DURATION = 500;
  var QUICK_ADD_SHEET_EASING = 'cubic-bezier(0.22, 0.9, 0.24, 1)';

  function prefersReducedQuickAddMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function cancelQuickAddAnimations(panel) {
    if (!panel) {
      return;
    }

    var sheet = panel.querySelector('.bdl-cart-quick-add-panel__sheet');
    var backdrop = panel.querySelector('.bdl-cart-quick-add-panel__backdrop');

    if (sheet && sheet._bdlQuickAddAnimation) {
      sheet._bdlQuickAddAnimation.cancel();
      sheet._bdlQuickAddAnimation = null;
    }

    if (backdrop && backdrop._bdlQuickAddAnimation) {
      backdrop._bdlQuickAddAnimation.cancel();
      backdrop._bdlQuickAddAnimation = null;
    }
  }

  function getQuickAddSheetTravel(sheet) {
    if (!sheet) {
      return 0;
    }

    return Math.max(sheet.offsetHeight, sheet.getBoundingClientRect().height, 1);
  }

  function applyQuickAddSheetTransform(sheet, travel, opacity) {
    if (!sheet) {
      return;
    }

    sheet.style.transition = 'none';
    sheet.style.transform = 'translate3d(0, ' + travel + 'px, 0)';
    sheet.style.opacity = String(opacity);
  }

  function commitQuickAddSheetOpen(panel) {
    var sheet = panel.querySelector('.bdl-cart-quick-add-panel__sheet');
    var backdrop = panel.querySelector('.bdl-cart-quick-add-panel__backdrop');

    if (sheet) {
      sheet.style.transition = 'none';
      sheet.style.transform = 'translate3d(0, 0, 0)';
      sheet.style.opacity = '1';
    }

    if (backdrop) {
      backdrop.style.transition = 'none';
      backdrop.style.opacity = '1';
    }
  }

  function getQuickAddViewportCap(panel) {
    if (panel) {
      var drawer = panel.closest('#CartDrawer');

      if (drawer) {
        return Math.floor(drawer.getBoundingClientRect().height * 0.94);
      }
    }

    return Math.floor(window.innerHeight * 0.94);
  }

  function canOpenCartQuickAdd(trigger) {
    return !!getQuickAddPanel(trigger);
  }

  function resetQuickAddSheet(panel) {
    if (!panel) {
      return;
    }

    var sheet = panel.querySelector('.bdl-cart-quick-add-panel__sheet');
    var body = panel.querySelector('.bdl-cart-quick-add-panel__body');
    var backdrop = panel.querySelector('.bdl-cart-quick-add-panel__backdrop');

    if (sheet) {
      sheet.style.height = '';
      sheet.style.transition = '';
      sheet.style.transform = '';
      sheet.style.opacity = '';
    }

    if (backdrop) {
      backdrop.style.transition = '';
      backdrop.style.opacity = '';
    }

    if (body) {
      body.style.maxHeight = '';
      body.style.overflowY = '';
    }
  }

  function fitQuickAddSheetSync(panel) {
    var sheet = panel.querySelector('.bdl-cart-quick-add-panel__sheet');
    var body = panel.querySelector('.bdl-cart-quick-add-panel__body');
    var header = panel.querySelector('.bdl-cart-quick-add-panel__header');
    var holder = panel.querySelector('[data-bdl-cart-quick-add-holder]');

    if (!sheet || !body || !holder) {
      return;
    }

    var viewportCap = getQuickAddViewportCap(panel);
    var headerHeight = header ? header.getBoundingClientRect().height : 0;
    var bodyStyles = window.getComputedStyle(body);
    var bodyPaddingTop = parseFloat(bodyStyles.paddingTop) || 0;
    var bodyPaddingBottom = parseFloat(bodyStyles.paddingBottom) || 0;
    var contentHeight = holder.scrollHeight;
    var totalNeeded = headerHeight + bodyPaddingTop + contentHeight + bodyPaddingBottom;

    if (totalNeeded <= viewportCap) {
      sheet.style.height = totalNeeded + 'px';
      body.style.overflowY = 'visible';
      body.style.maxHeight = 'none';
    } else {
      sheet.style.height = '';
      body.style.maxHeight = Math.max(120, viewportCap - headerHeight) + 'px';
      body.style.overflowY = 'auto';
    }
  }

  function fitQuickAddSheet(panel) {
    if (!panel) {
      return;
    }

    requestAnimationFrame(function () {
      fitQuickAddSheetSync(panel);
    });
  }

  function setQuickAddSheetClosed(panel) {
    var sheet = panel.querySelector('.bdl-cart-quick-add-panel__sheet');
    var backdrop = panel.querySelector('.bdl-cart-quick-add-panel__backdrop');
    var travel = getQuickAddSheetTravel(sheet);

    applyQuickAddSheetTransform(sheet, travel, 0.98);

    if (backdrop) {
      backdrop.style.transition = 'none';
      backdrop.style.opacity = '0';
    }

    void panel.offsetHeight;
  }

  function animateQuickAddSheetOpen(panel, callback) {
    var sheet = panel.querySelector('.bdl-cart-quick-add-panel__sheet');
    var backdrop = panel.querySelector('.bdl-cart-quick-add-panel__backdrop');

    cancelQuickAddAnimations(panel);

    if (prefersReducedQuickAddMotion() || !sheet || typeof sheet.animate !== 'function') {
      commitQuickAddSheetOpen(panel);
      if (callback) {
        callback();
      }
      return;
    }

    panel.classList.add('is-animating');
    setQuickAddSheetClosed(panel);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var travel = getQuickAddSheetTravel(sheet);

        applyQuickAddSheetTransform(sheet, travel, 0.98);
        if (backdrop) {
          backdrop.style.transition = 'none';
          backdrop.style.opacity = '0';
        }

        void sheet.offsetHeight;

        var sheetAnimation = sheet.animate([
          { transform: 'translate3d(0, ' + travel + 'px, 0)', opacity: 0.98 },
          { transform: 'translate3d(0, 0, 0)', opacity: 1 }
        ], {
          duration: QUICK_ADD_SHEET_DURATION,
          easing: QUICK_ADD_SHEET_EASING,
          fill: 'forwards'
        });

        sheet._bdlQuickAddAnimation = sheetAnimation;

        var backdropAnimation = null;
        if (backdrop) {
          backdropAnimation = backdrop.animate([
            { opacity: 0 },
            { opacity: 1 }
          ], {
            duration: QUICK_ADD_BACKDROP_DURATION,
            easing: QUICK_ADD_SHEET_EASING,
            fill: 'forwards'
          });
          backdrop._bdlQuickAddAnimation = backdropAnimation;
        }

        var finished = false;
        var finishOpen = function () {
          if (finished) {
            return;
          }

          finished = true;
          cancelQuickAddAnimations(panel);
          commitQuickAddSheetOpen(panel);
          panel.classList.remove('is-animating');
          if (callback) {
            callback();
          }
        };

        sheetAnimation.onfinish = finishOpen;
        sheetAnimation.oncancel = finishOpen;
        window.setTimeout(finishOpen, QUICK_ADD_SHEET_DURATION + 120);
      });
    });
  }

  function animateQuickAddSheetClose(panel, callback) {
    var sheet = panel.querySelector('.bdl-cart-quick-add-panel__sheet');
    var backdrop = panel.querySelector('.bdl-cart-quick-add-panel__backdrop');

    cancelQuickAddAnimations(panel);

    if (prefersReducedQuickAddMotion() || !sheet || typeof sheet.animate !== 'function') {
      setQuickAddSheetClosed(panel);
      if (callback) {
        callback();
      }
      return;
    }

    panel.classList.add('is-animating');
    commitQuickAddSheetOpen(panel);

    requestAnimationFrame(function () {
      var travel = getQuickAddSheetTravel(sheet);

      var sheetAnimation = sheet.animate([
        { transform: 'translate3d(0, 0, 0)', opacity: 1 },
        { transform: 'translate3d(0, ' + travel + 'px, 0)', opacity: 0.98 }
      ], {
        duration: QUICK_ADD_SHEET_DURATION,
        easing: QUICK_ADD_SHEET_EASING,
        fill: 'forwards'
      });

      sheet._bdlQuickAddAnimation = sheetAnimation;

      var backdropAnimation = null;
      if (backdrop) {
        backdropAnimation = backdrop.animate([
          { opacity: 1 },
          { opacity: 0 }
        ], {
          duration: QUICK_ADD_BACKDROP_DURATION,
          easing: QUICK_ADD_SHEET_EASING,
          fill: 'forwards'
        });
        backdrop._bdlQuickAddAnimation = backdropAnimation;
      }

      var finished = false;
      var finishClose = function () {
        if (finished) {
          return;
        }

        finished = true;
        cancelQuickAddAnimations(panel);
        setQuickAddSheetClosed(panel);
        panel.classList.remove('is-animating');
        if (callback) {
          callback();
        }
      };

      sheetAnimation.onfinish = finishClose;
      sheetAnimation.oncancel = finishClose;
      window.setTimeout(finishClose, QUICK_ADD_SHEET_DURATION + 120);
    });
  }

  function getQuickAddPanel(trigger) {
    var drawer = trigger && trigger.closest('#CartDrawer');
    if (drawer) {
      return drawer.querySelector('[data-bdl-cart-quick-add-panel]');
    }

    if (trigger && trigger.closest('#CartPageForm, .template-cart')) {
      var pageScope = trigger.closest('.page-content') || document;
      return pageScope.querySelector('[data-bdl-cart-quick-add-panel]');
    }

    // Product-page Preview buttons: use the page panel, not the cart drawer one.
    var panels = document.querySelectorAll('[data-bdl-cart-quick-add-panel]');
    for (var i = 0; i < panels.length; i++) {
      if (!panels[i].closest('#CartDrawer')) {
        // Keep fixed positioning relative to the viewport (parents may use transform).
        if (panels[i].parentElement !== document.body) {
          document.body.appendChild(panels[i]);
        }
        return panels[i];
      }
    }

    return null;
  }

  function openQuickAddPanel(panel, options) {
    if (!panel) {
      return;
    }

    options = options || {};

    panel.removeAttribute('hidden');
    panel.classList.remove('is-open');
    panel.classList.add('is-preparing');
    setQuickAddSheetClosed(panel);

    if (options.fitSheet) {
      fitQuickAddSheetSync(panel);
      setQuickAddSheetClosed(panel);
    }

    animateQuickAddSheetOpen(panel, function () {
      panel.classList.add('is-open');
      panel.classList.remove('is-preparing', 'is-animating');
      activeQuickAddPanel = panel;
      document.documentElement.classList.add('bdl-cart-quick-add-open');
    });
  }

  function finishQuickAddOpen(panel) {
    if (!panel) {
      return;
    }

    panel.removeAttribute('hidden');
    panel.classList.remove('is-open', 'is-preparing');
    openQuickAddPanel(panel, { fitSheet: true });

    window.setTimeout(function () {
      fitQuickAddSheetSync(panel);
    }, QUICK_ADD_SHEET_DURATION + 40);
  }

  function closeQuickAddPanel(panel) {
    panel = panel || activeQuickAddPanel;
    if (!panel || (!panel.classList.contains('is-open') && !panel.classList.contains('is-animating'))) {
      return;
    }

    panel.classList.remove('is-open', 'is-preparing');
    if (activeQuickAddPanel === panel) {
      activeQuickAddPanel = null;
    }
    document.documentElement.classList.remove('bdl-cart-quick-add-open');

    var finishClose = function () {
      resetQuickAddSheet(panel);
      panel.classList.remove('is-preparing', 'is-animating');
      panel.setAttribute('hidden', '');
      var holder = panel.querySelector('[data-bdl-cart-quick-add-holder]');
      if (holder) {
        teardownQuickAddProduct(holder);
        holder.innerHTML = '';
      }
    };

    animateQuickAddSheetClose(panel, finishClose);
  }

  function getThemeRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }

    if (typeof theme !== 'undefined' && theme.routes && theme.routes.home) {
      return theme.routes.home;
    }

    return '/';
  }

  function teardownQuickAddProduct(holder) {
    if (!holder || typeof theme === 'undefined' || !theme.sections) {
      return;
    }

    var section = holder.querySelector('[data-section-id]');
    if (section) {
      theme.sections._removeInstance(section.getAttribute('data-section-id'));
    }
  }

  function openCartQuickAdd(handle, trigger) {
    if (!handle || cartQuickAddLoading || !canOpenCartQuickAdd(trigger)) {
      return;
    }

    var panel = getQuickAddPanel(trigger);
    var holder = panel ? panel.querySelector('[data-bdl-cart-quick-add-holder]') : null;

    if (!panel || !holder || typeof theme === 'undefined' || !theme.routes) {
      return;
    }

    cartQuickAddLoading = true;

    if (trigger) {
      trigger.classList.add('is-loading');
      trigger.disabled = true;
    }

    teardownQuickAddProduct(holder);
    holder.innerHTML = '<div class="bdl-cart-quick-add-panel__loading" aria-hidden="true"></div>';

    var root = getThemeRoot();
    var url = root + 'products/' + encodeURIComponent(handle) + '?view=cart-quick-add';

    fetch(url)
      .then(function (response) {
        if (!response.ok) {
          throw new Error('quick add fetch failed');
        }

        return response.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var productRoot = doc.querySelector('[data-bdl-cart-quick-add-product]');

        if (!productRoot) {
          throw new Error('quick add product missing');
        }

        holder.innerHTML = '';
        holder.appendChild(productRoot);

        try {
          initQuickAddProduct(holder);
          finishQuickAddOpen(panel);
        } catch (error) {
          console.error(error);
          holder.innerHTML = '<p class="bdl-cart-quick-add-panel__error">Unable to load product options. Please try again.</p>';
          finishQuickAddOpen(panel);
        }
      })
      .catch(function () {
        holder.innerHTML = '<p class="bdl-cart-quick-add-panel__error">Unable to load product options. Please try again.</p>';
        finishQuickAddOpen(panel);
      })
      .finally(function () {
        cartQuickAddLoading = false;

        if (trigger) {
          trigger.classList.remove('is-loading');
          trigger.disabled = false;
        }
      });
  }

  function updateQuickAddPrice(container, variant) {
    if (!variant || typeof theme === 'undefined') {
      return;
    }

    var priceEl = container.querySelector('[data-product-price]');
    var compareEl = container.querySelector('[data-compare-price]');
    var saveEl = container.querySelector('[data-save-price]');
    var priceWrap = container.querySelector('[data-product-price-wrap]');
    var compareA11y = container.querySelector('[data-compare-price-a11y]');
    var priceA11y = container.querySelector('[data-a11y-price]');

    if (priceEl) {
      priceEl.innerHTML = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);
      priceEl.classList.toggle('on-sale', variant.compare_at_price > variant.price);
    }

    if (variant.compare_at_price > variant.price) {
      if (compareEl) {
        compareEl.innerHTML = theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat);
      }
      if (priceWrap) {
        priceWrap.classList.remove('hide');
      }
      if (saveEl && theme.strings.savePrice) {
        var savings = variant.compare_at_price - variant.price;
        if (theme.settings.saveType === 'percent') {
          savings = Math.round((savings * 100) / variant.compare_at_price) + '%';
        } else {
          savings = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
        }
        saveEl.innerHTML = theme.strings.savePrice.replace('[saved_amount]', savings);
        saveEl.classList.remove('hide');
      }
      if (compareA11y) {
        compareA11y.setAttribute('aria-hidden', 'false');
      }
      if (priceA11y) {
        priceA11y.setAttribute('aria-hidden', 'false');
      }
    } else {
      if (priceWrap) {
        priceWrap.classList.add('hide');
      }
      if (saveEl) {
        saveEl.classList.add('hide');
      }
      if (compareA11y) {
        compareA11y.setAttribute('aria-hidden', 'true');
      }
      if (priceA11y) {
        priceA11y.setAttribute('aria-hidden', 'true');
      }
    }
  }

  function updateQuickAddButton(container, variant) {
    var cartBtn = container.querySelector('[data-add-to-cart]');
    var cartBtnText = container.querySelector('[data-add-to-cart-text]');

    if (!cartBtn || !cartBtnText) {
      return;
    }

    if (variant && variant.available) {
      cartBtn.disabled = false;
      cartBtn.classList.remove('disabled');
      cartBtnText.textContent = cartBtnText.getAttribute('data-default-text') || cartBtnText.textContent;
    } else if (variant) {
      cartBtn.disabled = true;
      cartBtn.classList.add('disabled');
      cartBtnText.textContent = (typeof theme !== 'undefined' && theme.strings.soldOut) ? theme.strings.soldOut : 'Sold out';
    } else {
      cartBtn.disabled = true;
      cartBtn.classList.add('disabled');
      cartBtnText.textContent = (typeof theme !== 'undefined' && theme.strings.unavailable) ? theme.strings.unavailable : 'Unavailable';
    }
  }

  function updateQuickAddImage(container, variant) {
    if (!variant) {
      return;
    }

    var gallery = container.querySelector('[data-bdl-cart-quick-add-gallery]');
    if (!gallery) {
      return;
    }

    var mediaId = variant.featured_media && variant.featured_media.id
      ? variant.featured_media.id
      : (variant.featured_image && variant.featured_image.id ? variant.featured_image.id : null);

    var slide = mediaId
      ? container.querySelector('[data-bdl-cart-quick-add-slide][data-media-id="' + mediaId + '"]')
      : null;

    if (!slide && variant.featured_image && variant.featured_image.src) {
      var slides = container.querySelectorAll('[data-bdl-cart-quick-add-slide]');
      slides.forEach(function (candidate) {
        var img = candidate.querySelector('img');
        if (img && img.src.indexOf(variant.featured_image.src.split('?')[0]) !== -1) {
          slide = candidate;
        }
      });
    }

    if (!slide) {
      return;
    }

    container.querySelectorAll('[data-bdl-cart-quick-add-slide]').forEach(function (item) {
      item.classList.toggle('is-active', item === slide);
    });

    gallery.scrollTo({
      left: slide.offsetLeft - gallery.offsetLeft,
      behavior: 'smooth'
    });
  }

  function initQuickAddGallery(container) {
    var gallery = container.querySelector('[data-bdl-cart-quick-add-gallery]');
    var activeSlide = container.querySelector('[data-bdl-cart-quick-add-slide].is-active');

    if (!gallery) {
      return;
    }

    if (typeof window.bdlInitDragScroll === 'function') {
      window.bdlInitDragScroll(gallery);
    }

    if (!activeSlide || gallery.scrollWidth <= gallery.clientWidth) {
      return;
    }

    gallery.scrollLeft = activeSlide.offsetLeft - gallery.offsetLeft;
  }

  function initQuickAddProduct(holder) {
    var container = holder.querySelector('[data-bdl-cart-quick-add-product]');
    if (!container || typeof theme === 'undefined') {
      return;
    }

    var form = container.querySelector('.product-single__form');
    if (form) {
      new theme.AjaxProduct(form);
    }

    var variantJson = container.querySelector('[data-variant-json]');
    if (variantJson && theme.Variants) {
      var variantsObject = JSON.parse(variantJson.innerHTML);

      new theme.Variants({
        container: container,
        enableHistoryState: false,
        singleOptionSelector: '[data-variant-input]',
        originalSelectorId: '[data-product-select]',
        variants: variantsObject
      });

      container.addEventListener('variantChange', function (event) {
        var variant = event.detail && event.detail.variant;
        updateQuickAddPrice(container, variant);
        updateQuickAddButton(container, variant);
        updateQuickAddImage(container, variant);
      });
    }

    initQuickAddGallery(container);
  }

  function loadUpsellGrids() {
    var grids = document.querySelectorAll('[data-bdl-cart-upsell-grid][data-bdl-cart-upsell-awaiting]');
    if (!grids.length) {
      return Promise.resolve();
    }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    return Promise.all(Array.prototype.map.call(grids, function (grid) {
      var sectionHandle = grid.getAttribute('data-bdl-cart-upsell-section') || 'bdl-cart-trending-upsell';
      var collectionHandle = grid.getAttribute('data-bdl-cart-upsell-collection') || 'trending';
      var sortBy = grid.getAttribute('data-bdl-cart-upsell-sort') || 'best-selling';
      var isCartPage = grid.getAttribute('data-bdl-cart-upsell-cart-page') === 'true' || !!grid.closest('#CartPageForm');
      var url = root + 'collections/' + encodeURIComponent(collectionHandle)
        + '?sort_by=' + encodeURIComponent(sortBy)
        + '&sections=' + encodeURIComponent(sectionHandle);

      return fetch(url)
        .then(function (response) {
          if (!response.ok) {
            throw new Error('upsell fetch failed');
          }

          return response.json();
        })
        .then(function (data) {
          var html = data && data[sectionHandle];
          if (!html) {
            return;
          }

          html = extractSectionHtml(html);
          grid.innerHTML = html;
          grid.removeAttribute('data-bdl-cart-upsell-awaiting');
        });
    })).catch(function () {
      return null;
    });
  }

  function fetchAndApplyUpsell(token) {
    if (typeof theme === 'undefined' || !theme.cart || typeof theme.cart.getCart !== 'function') {
      return Promise.resolve(null);
    }

    return theme.cart.getCart()
      .then(function (cart) {
        if (token !== upsellSyncToken) {
          return null;
        }

        applyUpsellFromCart(cart);
        return cart;
      })
      .catch(function () {
        return null;
      });
  }

  function scheduleUpsellSync(delay) {
    if (upsellSyncTimer) {
      clearTimeout(upsellSyncTimer);
      upsellSyncTimer = null;
    }

    var token = ++upsellSyncToken;
    var wait = delay == null ? UPSELL_SYNC_DELAY : delay;

    upsellSyncTimer = window.setTimeout(function () {
      upsellSyncTimer = null;
      fetchAndApplyUpsell(token);
    }, wait);
  }

  function syncCartUpsell() {
    if (upsellSyncTimer) {
      clearTimeout(upsellSyncTimer);
      upsellSyncTimer = null;
    }

    var token = ++upsellSyncToken;
    return fetchAndApplyUpsell(token);
  }

  function highlightUpsellTitle(upsell) {
    if (!upsell || upsell.hidden) {
      return;
    }

    var title = upsell.querySelector('[data-bdl-cart-upsell-title]');
    if (!title) {
      return;
    }

    title.classList.remove('bdl-cart-upsell__titles--highlight');
    void title.offsetWidth;
    title.classList.add('bdl-cart-upsell__titles--highlight');

    window.setTimeout(function () {
      title.classList.remove('bdl-cart-upsell__titles--highlight');
    }, 1100);
  }

  document.addEventListener('click', function (event) {
    var closeBtn = event.target.closest('[data-bdl-cart-quick-add-close]');
    if (closeBtn) {
      event.preventDefault();
      closeQuickAddPanel(closeBtn.closest('[data-bdl-cart-quick-add-panel]'));
      return;
    }

    var quickAddBtn = event.target.closest('[data-bdl-cart-quick-add]');
    if (quickAddBtn) {
      event.preventDefault();
      event.stopPropagation();
      openCartQuickAdd(quickAddBtn.getAttribute('data-product-handle'), quickAddBtn);
      return;
    }

    var button = event.target.closest('.js-cart-item-remove');
    if (!button || typeof theme === 'undefined' || !theme.cart) {
      return;
    }

    event.preventDefault();

    var key = button.dataset.id;
    if (!key) {
      return;
    }

    button.classList.add('is-loading');
    button.disabled = true;

    theme.cart.changeItem(key, 0)
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            cart: cart
          }
        }));
        document.dispatchEvent(new CustomEvent('cart:build'));
      })
      .catch(function () {
        button.classList.remove('is-loading');
        button.disabled = false;
      });
  });

  document.addEventListener('ajaxProduct:added', function () {
    closeQuickAddPanel();
    scheduleUpsellSync();

    window.setTimeout(function () {
      var upsell = document.querySelector('[data-bdl-cart-upsell]');
      highlightUpsellTitle(upsell);
    }, UPSELL_SYNC_DELAY + 80);
  });

  document.addEventListener('cart:updated', function () {
    scheduleUpsellSync();
  });

  document.addEventListener('cart:build', function () {
    window.setTimeout(function () {
      initUpsellCollapsibles();
      scheduleUpsellSync(0);
    }, 120);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      loadUpsellGrids().then(function () {
        initUpsellCollapsibles();
        syncCartUpsell();
      });
    });
  } else {
    loadUpsellGrids().then(function () {
      initUpsellCollapsibles();
      syncCartUpsell();
    });
  }
})();
